// define a mixin object
export const panelValidation = {
  methods: {
    validatePanelRow(length, width, amount, lengthHasFinish, widthHasFinish) {
      if (!width || !length || !amount) {
        // No message needed ??
        return null
      }
      let minSizeLength = 50
      let minSizeWidth = 50

      // If there is some finish selected (NOTE: No finish available = false, No finish selected = 0)
      let finish = !this.$store.getters.materialFinish ? false : this.$store.getters.materialFinish
      // console.log('finish', finish)
      if ((lengthHasFinish || widthHasFinish) && finish !== false) {
        minSizeLength = 70
        minSizeWidth = 70

        if (length !== null && width !== null && parseFloat(length) === parseFloat(width)) {
          // Take Width as the short side..., check if there is finish selected for the LENGTH, then 100mm for the WIDTH
          // console.log('Width is the short side X ')
          if (lengthHasFinish) {
            minSizeLength = 100
          } else if (widthHasFinish) {
            minSizeWidth = 100
          }
        } else if (length !== null && width !== null && parseFloat(length) > parseFloat(width)) {
          // Width is the short side..., check if there is finish selected for the LENGTH, then 100mm for the WIDTH
          // console.log('Width is the short side')
          if (widthHasFinish) {
            minSizeWidth = 100
          }
        } else if (length !== null && width !== null && parseFloat(length) <= parseFloat(width)) {
          // Length is the short side..., check if there is finish selected for the WIDTH, then 100mm for the LENGTH
          // console.log('Length is the short side')
          if (lengthHasFinish) {
            minSizeLength = 100
          }
        }
      }

      let material = !this.$store.getters.material ? false : this.$store.getters.material

      let element = ''
      let message = ''

      // Validate minimum length/width
      if (minSizeLength > parseFloat(length) || parseFloat(length) > material.total_length - 30) {
        // console.log('material', material)
        element = 'length'
        message = 'Lengte moet minimaal ' + minSizeLength + ' mm zijn en mag maximaal ' + (material.total_length - 30) + ' mm zijn'
      } else if (minSizeWidth > parseFloat(width) || parseFloat(width) > material.total_width - 30) {
        // console.log('material', material)
        element = 'width'
        message = 'Breedte moet minimaal ' + minSizeWidth + ' mm zijn en mag maximaal ' + (material.total_width - 30) + ' mm zijn'
      }

      // Validate maximum length/width when using finish
      // If both length/width are > 1600mm than only one side has to be less than 1600mm
      if ((lengthHasFinish || widthHasFinish) && finish !== false) {
        let maxSize = 1600
        if (parseFloat(length) > maxSize && parseFloat(width) > maxSize) {
          element = 'length'
          message = 'Maximale paneelafmeting is behaald. Een van de twee lengtes moet onder de 1600mm zijn.'
        }
      }

      // In case of decimal values, check if number ends with .5
      if (!Number.isInteger(parseFloat(length))) {
        let decimal = Number((parseFloat(length) - Math.trunc(parseFloat(length))).toFixed(2));
        if (decimal !== 0.5) {
          element = 'length'
          message = 'Paneel afmeting alleen mogelijk met een nauwkeurigheid van 0.5 millimeter.'
        }
      } else if (!Number.isInteger(parseFloat(width))) {
        let decimal = Number((parseFloat(width) - Math.trunc(parseFloat(width))).toFixed(2));
        if (decimal !== 0.5) {
          element = 'width'
          message = 'Paneel afmeting alleen mogelijk met een nauwkeurigheid van 0.5 millimeter.'
        }
      }

      if (message !== '') {
        return [element, message]
      }

      return null
    }
  }
}
